<template>
    <div class="artwork" :class="{ favorite: favorite, full: full }">
        <div class="image">
            <img :src="image" :alt="alt" v-if="image" loading="lazy" />
        </div>
        <div class="details">
            <template v-if="full">
                <h3 class="artist-name" v-if="showArtist">
                    {{ artwork.artist && artwork.artist.name }}
                </h3>
                <h2 class="artwork-title">{{ artwork.title }}</h2>
            </template>
            <template v-if="teaser">
                <h4 class="artist-name" v-if="showArtist">
                    {{ artwork.artist && artwork.artist.name }}
                </h4>
                <div class="title-line">
                    <h3 class="artwork-title"><router-link :to="artwork.url">{{ artwork.title }}</router-link></h3>
                    <div class="favorites-availability">
                        <span
                            class="favorite-indicator"
                            @click.stop="toggleFavorite"
                            >★</span
                        ><span class="availability-sold" v-if="artwork.sold">●</span>
                    </div>
                </div>
            </template>
            <div class="dimensions">
                <span class="height">{{ artwork.height }}{{ unit }} h</span>
                x
                <span class="width">{{ artwork.width }}{{ unit }} w</span>
            </div>
            <template v-if="full">
                <div class="medium" v-if="!hideMedium">{{ artwork.medium }}</div>
                <div class="year">{{ artwork.year }}</div>
            </template>
            <div class="price">{{ artwork.availability }}</div>
            <template v-if="full">
                <div class="body" v-html="artwork.body" />
                <ul class="links">
                    <li>
                        <a class="button" @click.stop="toggleFavorite">
                            <span class="material-icons icon favorite-indicator"
                                >star</span
                            >
                            Favorite
                        </a>
                    </li>
                    <li>
                        <a class="button" @click.stop="share">
                            <span class="material-icons icon">{{ shareIcon }}</span>
                            {{ shareText }}
                        </a>
                    </li>
                    <li>
                        <a class="button" @click.stop="inquire">
                            <span class="material-icons icon"
                                >question_mark</span
                            >
                            Inquire
                        </a>
                    </li>
                </ul>
            </template>
        </div>
    </div>
</template>

<script>
import { Favorites } from "@/state.js";

export default {
    name: "Artwork",
    props: {
        artwork: {
            type: Object,
            required: true,
        },
        teaser: {
            type: Boolean,
            default: true,
        },
        showArtist: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            favorites: Favorites,
            shareIcon: 'forward',
        };
    },
    computed: {
        unit() {
            const vm = this;
            return `${vm.artwork.units}`.toLowerCase() == "foot" ? "'" : '"';
        },
        image() {
            const vm = this;
            return vm.full ? vm.artwork.fullImage : vm.artwork.thumbnail;
        },
        full() {
            const vm = this;
            return !vm.teaser;
        },
        favorite() {
            const vm = this;
            return vm.favorites.includes(vm.artwork.nid);
        },
        alt() {
            const vm = this;
            if (vm.artwork.artist) {
                return `${vm.artwork.title} by ${vm.artwork.artist.name}`;
            } else {
                return vm.artwork.title;
            }
        },
        shareText() {
            const vm = this;
            return vm.shareIcon == 'forward' ? 'Share' : 'Link copied';
        },
        hideMedium() {
            const vm = this;
            if (vm.artwork.availability && vm.artwork.medium) {
                return vm.artwork.availability.toString().indexOf(vm.artwork.medium.toString()) > 0;
            }
            return false;
        }
    },
    methods: {
        toggleFavorite() {
            const vm = this;
            if (vm.favorite) {
                let index = vm.favorites.indexOf(vm.artwork.nid);
                if (index > -1) {
                    vm.favorites.splice(index, 1);
                }
            } else {
                vm.favorites.push(vm.artwork.nid);
            }
        },
        share() {
            const vm = this;
            const url = vm.artwork.url;
            const { href } = vm.$router.resolve(url);
            const fullPath = `${window.location.origin}${href}`;
            navigator.clipboard.writeText(fullPath);
            vm.shareIcon = 'done';
            setTimeout(() => vm.shareIcon = 'forward', 2000);
        },
        inquire() {
            const vm = this;
            vm.$router.push({
                name: "contact",
                query: { artwork: vm.artwork.nid },
            });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
